import { useGetPageFAQQuery } from '../../redux/baseApi';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import './pageFAQ.scss';
import Spinner from '../../components/Spinner/Spinner';

const PageFAQ = () => {

  const {
    data: page,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetPageFAQQuery();

  let infoComponent;
  if (isLoading) {
    infoComponent = (<Spinner />);
  } else if (isSuccess) {
    infoComponent = (<div>
        <BlocksRenderer content={page.data.attributes.content} />
      </div>
    );
  } else if (isError) {
    infoComponent = (
      <div>
        Ошибка: {error}
      </div>
    )
  }

  return (
    <div className="content-column">
      <div className="page-faq">
        <div>
          {infoComponent}
        </div>
      </div>
    </div>);

};

export default PageFAQ;
